import React from 'react';
import { CatchError } from '@guildeducationinc/recess';
import { logDataDogError } from '@src/utilities/datadog';

export const ErrorBoundary: React.FC = ({ children }) => {
	return (
		<CatchError
			onError={(error, info) => {
				logDataDogError(error, 'ErrorBoundaryError', { info });
			}}
		>
			{children}
		</CatchError>
	);
};
